import React, { createContext, useReducer } from "react";
import { CATEGORY_LIST_FAILURE, CATEGORY_LIST_REQUEST, CATEGORY_LIST_SUCCESS, PRODUCT_LIST_FAILURE, PRODUCT_LIST_REQUEST, PRODUCT_LIST_SUCCESS, ORDER_SET_TYPE, ORDER_ADD_ITEM, ORDER_REMOVE_ITEM, ORDER_CLEAR, PAYMENT_SET_TYPE, ORDER_CREATE_REQUEST, ORDER_CREATE_SUCCESS, ORDER_CREATE_FAILURE, ORDER_LIST_SUCCESS, ORDER_LIST_REQUEST, ORDER_LIST_FAILURE, SCREEN_SET_WIDTH, ORDER_QUEUE_REQUEST, ORDER_QUEUE_FAILURE, ORDER_QUEUE_SUCCESS, WHATSAPP_NUMBER_SET, PIXQRCODE_SET, LOYALTY_POINTS_REQUEST, LOYALTY_POINTS_SUCCESS, LOYALTY_POINTS_FAILURE, LOYALTY_POINTS_CLEAR, LOYALTY_CALCULATE_POINTS_REQUEST, LOYALTY_CALCULATE_POINTS_SUCCESS, LOYALTY_CALCULATE_POINTS_FAILURE } from "./constants"

//initial state
const initialState = {
    wideScreen: false,
    categoryList: { loading: true },
    productList: { loading: true },
    order: {
        orderType: 'Eat in',
        orderItems: [],
        paymentType: 'Pay here',
        whatsAppNumber: '', // Add WhatsApp number to the order state
    },
    orderCreate: { loading: true },
    orderList: { loading: true },
    queueList: { loading: true },
    loyaltyPoints: { loading: false, points: 0, error: null },
    loyaltyCalculation: { loading: false, pointsNeeded: 0, error: null },
};

//reducer function
const reducer = (state, action) => {
    switch (action.type) {
        case CATEGORY_LIST_REQUEST:
            return {
                ...state,
                categoryList: { loading: true }
            };
        case CATEGORY_LIST_SUCCESS:
            return {
                ...state,
                categoryList: { loading: false, categories: action.payload }
            };
        case CATEGORY_LIST_FAILURE:
            return {
                ...state,
                categoryList: { loading: false, error: action.payload }
            };

        case PRODUCT_LIST_REQUEST:
            return {
                ...state,
                productList: { loading: true }
            };
        case PRODUCT_LIST_SUCCESS:
            return {
                ...state,
                productList: { loading: false, products: action.payload }
            };
        case PRODUCT_LIST_FAILURE:
            return {
                ...state,
                productList: { loading: false, error: action.payload }
            };

        case ORDER_SET_TYPE:
            return {
                ...state,
                order: { ...state.order, orderType: action.payload }
            };
        case ORDER_ADD_ITEM: {

            const item = action.payload;
            const existItem = state.order.orderItems.find(x => x.uniqueId === item.uniqueId);

            const orderItems = existItem ? state.order.orderItems.map(x => x.uniqueId === item.uniqueId ? item : x) : [...state.order.orderItems, item];

            const itemsCount = orderItems.reduce((a, c) => a + c.quantity, 0);
            let itemsPrice = orderItems.reduce((a, c) => a + c.quantity * c.preco, 0);

            let precoModificadores = 0;

            orderItems.forEach((a) => {
                if (a.produtoProdutoModificador) {
                    a.produtoProdutoModificador.forEach((b) => {
                        if (b.produtoModificador && b.produtoModificador.produtoModificadorItems) {
                            b.produtoModificador.produtoModificadorItems.filter((c) => c.visivel).forEach((c) => {
                                if (c.checked && c.preco) {
                                    precoModificadores = precoModificadores + c.preco;
                                }
                            })
                        }
                    })
                }
            })

            itemsPrice = itemsPrice + precoModificadores;

            // Calcula taxa de serviço (%) a partir do restaurante selecionado (se existir)
            let taxPercent = 0;
            try {
                const restRaw = localStorage.getItem('restaurante');
                if (restRaw) {
                    const rest = JSON.parse(restRaw);
                    taxPercent = Number(rest.serviceFeePercent || rest.ServiceFeePercent || 0) || 0;
                }
            } catch {}
            const tax = Math.round(((taxPercent / 100) * itemsPrice) * 100) / 100;
            const total = Math.round((itemsPrice + tax) * 100) / 100;

            return {
                ...state,
                order: { ...state.order, orderItems, itemsCount, tax, total, pixQrCode: null }
            };
        }
        case ORDER_REMOVE_ITEM: {
            const item = action.payload
            const orderItems = state.order.orderItems.filter(x => x.uniqueId !== item.uniqueId);

            const itemsCount = orderItems.reduce((a, c) => a + c.quantity, 0);
            let itemsPrice = orderItems.reduce((a, c) => a + c.quantity * c.preco, 0);

            let precoModificadores = 0;

            orderItems.forEach((a) => {
                if (a.produtoProdutoModificador) {
                    a.produtoProdutoModificador.forEach((b) => {
                        if (b.produtoModificador && b.produtoModificador.produtoModificadorItems) {
                            b.produtoModificador.produtoModificadorItems.filter((c) => c.visivel).forEach((c) => {
                                if (c.checked && c.preco) {
                                    precoModificadores = precoModificadores + c.preco;
                                }
                            })
                        }
                    })
                }
            })

            itemsPrice = itemsPrice + precoModificadores;

            let taxPercent2 = 0;
            try {
                const restRaw = localStorage.getItem('restaurante');
                if (restRaw) {
                    const rest = JSON.parse(restRaw);
                    taxPercent2 = Number(rest.serviceFeePercent || rest.ServiceFeePercent || 0) || 0;
                }
            } catch {}
            const tax = Math.round(((taxPercent2 / 100) * itemsPrice) * 100) / 100;
            const total = Math.round((itemsPrice + tax) * 100) / 100;


            return {
                ...state,
                order: { ...state.order, orderItems, itemsCount, tax, total }
            };
        }
        case ORDER_CLEAR:
            return {
                ...state,
                order: { ...state.order, orderItems: [], tax: 0, total: 0, itemsCount: 0 },
            };

        case PAYMENT_SET_TYPE:
            return {
                ...state,
                order: { ...state.order, paymentType: action.payload }
            };

        case ORDER_CREATE_REQUEST:
            return {
                ...state,
                orderCreate: { loading: true }
            };
        case ORDER_CREATE_SUCCESS:
            return {
                ...state,
                orderCreate: { loading: false, newOrder: action.payload }
            };
        case ORDER_CREATE_FAILURE:
            return {
                ...state,
                orderCreate: { loading: false, error: action.payload }
            };


        case ORDER_LIST_REQUEST:
            return {
                ...state, orderList: { loading: true }
            };
        case ORDER_LIST_SUCCESS:
            return {
                ...state,
                orderList: { loading: false, orders: action.payload }
            };
        case ORDER_LIST_FAILURE:
            return {
                ...state,
                orderList: { loading: false, error: action.payload }
            };
        case SCREEN_SET_WIDTH:
            return {
                ...state,
                wideScreen: true
            };

        case ORDER_QUEUE_REQUEST:
            return {
                ...state,
                queueList: { loading: true }
            };
        case ORDER_QUEUE_SUCCESS:
            return {
                ...state,
                queueList: { loading: false, queue: action.payload }
            };
        case ORDER_QUEUE_FAILURE:
            return {
                ...state,
                queueList: { loading: false, error: action.payload }
            };

        case WHATSAPP_NUMBER_SET:
            return {
                ...state,
                order: { ...state.order, whatsAppNumber: action.payload }
            };

        case PIXQRCODE_SET:
            return {
                ...state,
                order: { ...state.order, pixQrCode: action.payload }
            };

        // Loyalty Points cases
        case LOYALTY_POINTS_REQUEST:
            return {
                ...state,
                loyaltyPoints: { loading: true, points: 0, error: null }
            };
        case LOYALTY_POINTS_SUCCESS:
            return {
                ...state,
                loyaltyPoints: { loading: false, points: action.payload, error: null }
            };
        case LOYALTY_POINTS_FAILURE:
            return {
                ...state,
                loyaltyPoints: { loading: false, points: 0, error: action.payload }
            };
        case LOYALTY_POINTS_CLEAR:
            return {
                ...state,
                loyaltyPoints: { loading: false, points: 0, error: null }
            };

        // Loyalty Calculation cases
        case LOYALTY_CALCULATE_POINTS_REQUEST:
            return {
                ...state,
                loyaltyCalculation: { loading: true, pointsNeeded: 0, error: null }
            };
        case LOYALTY_CALCULATE_POINTS_SUCCESS:
            console.log("LOYALTY_CALCULATE_POINTS_SUCCESS - payload:", action.payload);
            return {
                ...state,
                loyaltyCalculation: { loading: false, pointsNeeded: action.payload, error: null }
            };
        case LOYALTY_CALCULATE_POINTS_FAILURE:
            return {
                ...state,
                loyaltyCalculation: { loading: false, pointsNeeded: 0, error: action.payload }
            };

        default:
            return state;
    }
}

//store provider - creating the context
export const Store = createContext();

// Fix: Properly define StoreProvider as a React function component
export const StoreProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <Store.Provider value={{ state, dispatch }}>
            {children}
        </Store.Provider>
    );
};
